import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function getProductReviews ({
	sortOrder = 2, filters = [], pageNumber = 1, pageSize = 5
} = {}) {

	try {

		let query = Object.entries({
			shortSku: window.shortSku,
			pageSize,
			pageNumber,
			sort: sortOrder
		})
			.map(([ key, value ]) => `${key}=${value}`)
			.join('&');
		// add filters if any
		query += filters.map((filter) => `&filter=${filter.value}`).join('');

		const response = await baseAPIRequest({
			url: `${baseURI}/reviews/?${encodeURI(query)}`,
			params: { method: 'GET' }
		});

		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to get reviews: ${error.message}`);

		}

		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default getProductReviews;
